import { render, staticRenderFns } from "./PageSpecificFaqQuestions.vue?vue&type=template&id=2c1be3ee"
import script from "./PageSpecificFaqQuestions.vue?vue&type=script&lang=ts"
export * from "./PageSpecificFaqQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports